import React from "react";
import { Accordion } from "@folio/stripes/components";
import { FormattedMessage } from "react-intl";
export var AccordionSection = function (_a) {
    var id = _a.id, labelId = _a.labelId, open = _a.open, onToggle = _a.onToggle, children = _a.children;
    return (React.createElement(Accordion, { id: id, label: React.createElement(FormattedMessage, { id: labelId }), open: open, onToggle: onToggle }, children));
};
